<template>
    <div>
        <div class="container-fluid">
            <CRow class="pr-2">
                <CCol col="12" xl="12" class="p-0">
                    <CCard>
                        <CCardBody>
                            <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
                                <span slot="title">
                                    <h6 class="w-100 mb-0 text-muted">Rezervácie</h6>
                                    Dostupnosť termínov
                                </span>

                                <div class="p-3">
                                    <CRow class="mb-3">
                                        <CCol md="4">
                                            <label class="font-weight-bold">Ubytovacia jednotka:</label>
                                            <a-select
                                                v-model="selectedCabin"
                                                style="width: 100%"
                                                @change="loadAvailability">
                                                <a-select-option
                                                    v-for="cabin in cabins"
                                                    :key="cabin.id"
                                                    :value="cabin.id">
                                                    {{ cabin.title }}
                                                </a-select-option>
                                            </a-select>
                                        </CCol>
                                        <CCol md="8" class="text-right">
                                            <a-radio-group v-model="availabilityMode" button-style="solid">
                                                <a-radio-button value="available">
                                                    <a-icon type="check" /> Dostupné
                                                </a-radio-button>
                                                <a-radio-button value="unavailable">
                                                    <a-icon type="close" /> Nedostupné
                                                </a-radio-button>
                                            </a-radio-group>
                                            <a-button type="primary" class="ml-3" @click="saveAvailability">
                                                <a-icon type="save" /> Uložiť zmeny
                                            </a-button>
                                        </CCol>
                                    </CRow>

                                    <div v-if="selectedCabin" class="availability-calendar">
                                        <div v-for="(monthData, index) in months" :key="index" class="month-block">
                                            <h5 class="month-title">{{ monthData.name }}</h5>
                                            <div class="calendar-grid">
                                                <div class="weekday-header" v-for="day in weekDays" :key="day">
                                                    {{ day }}
                                                </div>
                                                <div
                                                    v-for="day in monthData.days"
                                                    :key="day.date"
                                                    :class="getDayClass(day)"
                                                    @mousedown="startDrag(day, $event)"
                                                    @mouseenter="onDragOver(day)"
                                                    @mouseup="endDrag"
                                                    @contextmenu.prevent>
                                                    <span class="day-number">{{ day.number }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="load-more-container">
                                            <a-button
                                                v-if="!isLoadingMore"
                                                type="primary"
                                                size="large"
                                                @click="loadMoreMonths">
                                                <a-icon type="down" /> Načítaj ďalšie mesiace
                                            </a-button>
                                            <a-spin v-else size="large" />
                                        </div>
                                    </div>

                                    <div v-else class="text-center p-5 text-muted">
                                        <a-icon type="calendar" style="font-size: 48px;" />
                                        <p class="mt-3">Vyberte ubytovaciu jednotku</p>
                                    </div>
                                </div>

                                <div class="px-3 pb-3 pt-3 border-top">
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <strong class="mr-3">Legenda:</strong>
                                        </div>
                                        <div class="col-auto">
                                            <div class="legend-item d-inline-flex align-items-center mr-3">
                                                <span class="legend-color available"></span>
                                                <span>Dostupné</span>
                                            </div>
                                            <div class="legend-item d-inline-flex align-items-center mr-3">
                                                <span class="legend-color unavailable"></span>
                                                <span>Nedostupné</span>
                                            </div>
                                            <div class="legend-item d-inline-flex align-items-center">
                                                <span class="legend-color booked"></span>
                                                <span>Rezervované</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a-card>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </div>
    </div>
</template>

<script>
import {dataService} from "../_services";
import moment from 'moment';
import 'moment/locale/sk';

export default {
    name: "cabin-availability",
    data() {
        return {
            cabins: [],
            selectedCabin: null,
            availabilityMode: 'unavailable',
            weekDays: ['Po', 'Ut', 'St', 'Št', 'Pi', 'So', 'Ne'],
            months: [],
            unavailableDates: [],
            bookedDates: [],
            isDragging: false,
            dragStartDate: null,
            dragEndDate: null,
            dragMode: null,
            monthsToShow: 12,
            isLoadingMore: false,
            hasUnsavedChanges: false,
            originalUnavailableDates: []
        };
    },
    mounted() {
        this.fetchCabins();
        this.calculateMonthsToShow();
        this.generateMonths();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeRouteLeave(to, from, next) {
        if (this.hasUnsavedChanges) {
            const answer = window.confirm('Máte neuložené zmeny. Naozaj chcete opustiť stránku?');
            if (answer) {
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
    methods: {
        fetchCabins() {
            dataService.axiosFetch('content/cabins').then(results => {
                const data = results.data || results;
                this.cabins = Object.values(data).filter(item => item && item.id);

                // Automaticky vyselektuj prvú chatu
                if (this.cabins.length > 0) {
                    this.selectedCabin = this.cabins[0].id;
                    this.loadAvailability();
                }
            });
        },
        generateMonths() {
            this.months = [];
            const startMonth = moment().startOf('month');

            for (let i = 0; i < this.monthsToShow; i++) {
                const month = startMonth.clone().add(i, 'months');
                const monthData = {
                    name: month.format('MMMM YYYY'),
                    year: month.year(),
                    month: month.month(),
                    days: []
                };

                // Pridaj prázdne dni na začiatok
                const firstDayOfWeek = month.day();
                // Preveď nedeľu (0) na 7, aby pondelok bol 1
                const adjustedFirstDay = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
                for (let j = 0; j < adjustedFirstDay; j++) {
                    monthData.days.push({ empty: true });
                }

                // Pridaj dni mesiaca
                const daysInMonth = month.daysInMonth();
                for (let day = 1; day <= daysInMonth; day++) {
                    const date = month.clone().date(day);
                    const dayOfWeek = date.day();
                    monthData.days.push({
                        date: date.format('YYYY-MM-DD'),
                        number: day,
                        isPast: date.isBefore(moment(), 'day'),
                        isWeekend: dayOfWeek === 0 || dayOfWeek === 6
                    });
                }

                this.months.push(monthData);
            }
        },
        calculateMonthsToShow() {
            // Šírka kontajnera
            const containerWidth = window.innerWidth - 100; // odpočítaj padding/margin
            // Minimálna šírka mesiaca je 280px + 24px gap
            const monthWidth = 280 + 24;
            // Počet mesiacov na riadok
            const monthsPerRow = Math.floor(containerWidth / monthWidth);
            // Zobraz násobok riadkov (3 riadky = lepší UX)
            this.monthsToShow = Math.max(12, monthsPerRow * 3);
        },
        handleResize() {
            this.calculateMonthsToShow();
            this.generateMonths();
        },
        handleBeforeUnload(e) {
            if (this.hasUnsavedChanges) {
                e.preventDefault();
                e.returnValue = '';
                return '';
            }
        },
        loadMoreMonths() {
            if (this.isLoadingMore) return;

            this.isLoadingMore = true;

            // Simuluj malé oneskorenie pre lepší UX
            setTimeout(() => {
                const currentMonthCount = this.months.length;
                const startMonth = moment().startOf('month').add(currentMonthCount, 'months');

                // Vypočítaj koľko mesiacov pridať (rovnaký počet ako pri inicializácii)
                const monthsToAdd = this.monthsToShow;

                // Pridaj vypočítaný počet mesiacov
                for (let i = 0; i < monthsToAdd; i++) {
                    const month = startMonth.clone().add(i, 'months');
                    const monthData = {
                        name: month.format('MMMM YYYY'),
                        year: month.year(),
                        month: month.month(),
                        days: []
                    };

                    // Pridaj prázdne dni na začiatok
                    const firstDayOfWeek = month.day();
                    const adjustedFirstDay = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
                    for (let j = 0; j < adjustedFirstDay; j++) {
                        monthData.days.push({ empty: true });
                    }

                    // Pridaj dni mesiaca
                    const daysInMonth = month.daysInMonth();
                    for (let day = 1; day <= daysInMonth; day++) {
                        const date = month.clone().date(day);
                        const dayOfWeek = date.day();
                        monthData.days.push({
                            date: date.format('YYYY-MM-DD'),
                            number: day,
                            isPast: date.isBefore(moment(), 'day'),
                            isWeekend: dayOfWeek === 0 || dayOfWeek === 6
                        });
                    }

                    this.months.push(monthData);
                }

                this.isLoadingMore = false;

                // Načítaj dostupnosť pre nové mesiace
                this.loadAvailabilityForNewMonths();
            }, 300);
        },
        loadAvailabilityForNewMonths() {
            if (!this.selectedCabin) return;

            const lastMonth = this.months[this.months.length - 1];
            const firstNewMonth = this.months[this.months.length - this.monthsToShow];
            const startDate = moment(`${firstNewMonth.year}-${firstNewMonth.month + 1}-01`).format('YYYY-MM-DD');
            const endDate = moment(`${lastMonth.year}-${lastMonth.month + 1}-01`).endOf('month').format('YYYY-MM-DD');

            const params = {
                cabin_id: this.selectedCabin,
                start_date: startDate,
                end_date: endDate
            };

            dataService.axiosPost('cabin-availability', params).then(result => {
                const data = result.data?.data || result.data || result;

                // Pridaj nové nedostupné dátumy (bez duplikátov)
                const newUnavailable = [...(data.unavailable || [])];
                newUnavailable.forEach(date => {
                    if (!this.unavailableDates.includes(date)) {
                        this.unavailableDates.push(date);
                    }
                });

                // Pridaj nové rezervované dátumy
                const newBooked = [...(data.booked || [])];
                newBooked.forEach(date => {
                    if (!this.bookedDates.includes(date)) {
                        this.bookedDates.push(date);
                    }
                });
            });
        },
        loadAvailability() {
            if (!this.selectedCabin) return;

            const lastMonth = this.months[this.months.length - 1];
            const params = {
                cabin_id: this.selectedCabin,
                start_date: moment().format('YYYY-MM-DD'),
                end_date: moment(`${lastMonth.year}-${lastMonth.month + 1}-01`).endOf('month').format('YYYY-MM-DD')
            };

            dataService.axiosPost('cabin-availability', params).then(result => {
                // API vracia dáta v result.data.data
                const data = result.data?.data || result.data || result;

                // Použij spread operator na vytvorenie čistého poľa
                this.unavailableDates = [...(data.unavailable || [])];
                this.bookedDates = [...(data.booked || [])];

                // Ulož originálny stav pre porovnanie
                this.originalUnavailableDates = [...this.unavailableDates];
                this.hasUnsavedChanges = false;
            });
        },
        toggleDay(day) {
            if (day.empty || day.isPast) return;

            // Ak je deň rezervovaný, nemôžeme ho meniť
            if (this.bookedDates.includes(day.date)) return;

            this.changedDates.add(day.date);

            if (this.availabilityMode === 'unavailable') {
                if (!this.unavailableDates.includes(day.date)) {
                    this.unavailableDates.push(day.date);
                }
            } else {
                const index = this.unavailableDates.indexOf(day.date);
                if (index > -1) {
                    this.unavailableDates.splice(index, 1);
                }
            }
        },
        startDrag(day, event) {
            if (day.empty || day.isPast || this.bookedDates.includes(day.date)) return;

            this.isDragging = true;
            this.dragStartDate = day.date;
            this.dragEndDate = day.date;

            // Zisti ktoré tlačidlo myši bolo stlačené
            // 0 = ľavé, 2 = pravé
            if (event.button === 2) {
                // Pravé tlačidlo - opačný režim
                this.dragMode = this.availabilityMode === 'unavailable' ? 'available' : 'unavailable';
            } else {
                // Ľavé tlačidlo - normálny režim
                this.dragMode = this.availabilityMode;
            }
        },
        onDragOver(day) {
            if (!this.isDragging || day.empty || day.isPast) return;

            this.dragEndDate = day.date;
        },
        endDrag() {
            if (!this.isDragging) return;

            this.isDragging = false;

            // Aplikuj zmeny na všetky dni v rozsahu
            const dateRange = this.getDateRange(this.dragStartDate, this.dragEndDate);

            dateRange.forEach(date => {
                // Preskočiť rezervované dni
                if (this.bookedDates.includes(date)) return;

                // Použij dragMode namiesto availabilityMode
                if (this.dragMode === 'unavailable') {
                    if (!this.unavailableDates.includes(date)) {
                        this.unavailableDates.push(date);
                        this.hasUnsavedChanges = true;
                    }
                } else {
                    const index = this.unavailableDates.indexOf(date);
                    if (index > -1) {
                        this.unavailableDates.splice(index, 1);
                        this.hasUnsavedChanges = true;
                    }
                }
            });

            this.dragStartDate = null;
            this.dragEndDate = null;
            this.dragMode = null;
        },
        getDateRange(start, end) {
            const dates = [];
            const startMoment = moment(start);
            const endMoment = moment(end);

            // Zisti ktorý dátum je skôr
            const from = startMoment.isBefore(endMoment) ? startMoment : endMoment;
            const to = startMoment.isBefore(endMoment) ? endMoment : startMoment;

            // Vytvor pole všetkých dátumov v rozsahu
            for (let day = from.clone(); day.isSameOrBefore(to); day.add(1, 'day')) {
                dates.push(day.format('YYYY-MM-DD'));
            }

            return dates;
        },
        isInDragRange(date) {
            if (!this.isDragging || !this.dragStartDate || !this.dragEndDate) return false;

            const current = moment(date);
            const start = moment(this.dragStartDate);
            const end = moment(this.dragEndDate);

            // Zisti ktorý dátum je skôr
            const from = start.isBefore(end) ? start : end;
            const to = start.isBefore(end) ? end : start;

            return current.isSameOrAfter(from) && current.isSameOrBefore(to);
        },
        getDayClass(day) {
            if (day.empty) return 'calendar-day empty';

            const classes = ['calendar-day'];

            if (day.isPast) classes.push('past');
            if (day.isWeekend) classes.push('weekend');

            // Pridaj drag-selecting class pre dni v rozsahu
            if (this.isInDragRange(day.date)) {
                classes.push('drag-selecting');
                // Pridaj farbu podľa dragMode (nie availabilityMode)
                if (this.dragMode === 'unavailable') {
                    classes.push('drag-unavailable');
                } else {
                    classes.push('drag-available');
                }
            }

            if (this.bookedDates.includes(day.date)) classes.push('booked');
            else if (this.unavailableDates.includes(day.date)) classes.push('unavailable');
            else classes.push('available');

            return classes.join(' ');
        },
        saveAvailability() {
            if (!this.selectedCabin) {
                this.$message.warning('Žiadne zmeny na uloženie');
                return;
            }

            const params = {
                cabin_id: this.selectedCabin,
                unavailable_dates: this.unavailableDates
            };

            dataService.axiosPost('cabin-availability/save', params).then(() => {
                this.$message.success('Dostupnosť bola úspešne uložená');
                this.originalUnavailableDates = [...this.unavailableDates];
                this.hasUnsavedChanges = false;
            }).catch(() => {
                this.$message.error('Chyba pri ukladaní dostupnosti');
            });
        }
    }
};
</script>

<style scoped>
/* Fix pre vertikálne zarovnanie ikon v tlačidlách */
::v-deep .anticon {
    vertical-align: 0 !important;
}

.availability-calendar {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
    margin-top: 20px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.load-more-container {
    grid-column: 1 / -1;
    text-align: center;
    padding: 30px 0;
}

.month-block {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 16px;
    background: #fff;
}

.month-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    text-align: center;
    color: #262626;
}

.calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
}

.weekday-header {
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    color: #8c8c8c;
    padding: 8px 0;
}

.calendar-day {
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    border: 2px solid transparent;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.calendar-day.empty {
    cursor: default;
}

.calendar-day.past {
    opacity: 0.3;
    cursor: not-allowed;
}

.calendar-day.available {
    background: #52c41a;
    color: #fff;
}

.calendar-day.available.weekend {
    background: #73d13d;
}

.calendar-day.available:hover:not(.past) {
    background: #389e0d;
    transform: scale(1.1);
}

.calendar-day.unavailable {
    background: #ff4d4f;
    color: #fff;
}

.calendar-day.unavailable.weekend {
    background: #ff7875;
}

.calendar-day.unavailable:hover:not(.past) {
    background: #cf1322;
    transform: scale(1.1);
}

.calendar-day.booked {
    background: #1890ff;
    color: #fff;
    cursor: not-allowed;
}

.calendar-day.booked.weekend {
    background: #40a9ff;
}

.calendar-day.changed {
    border-color: #faad14;
    box-shadow: 0 0 0 2px rgba(250, 173, 20, 0.2);
}

.calendar-day.drag-selecting {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.3);
    transform: scale(1.05);
}

.calendar-day.drag-selecting.drag-unavailable {
    border-color: #ff7875;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.4);
}

.calendar-day.drag-selecting.drag-available {
    border-color: #73d13d;
    box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.4);
}

.day-number {
    font-size: 14px;
    font-weight: 600;
}

.legend-item {
    display: flex;
    align-items: center;
}

.legend-color {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border-radius: 2px;
}

.legend-color.available {
    background: #52c41a;
}

.legend-color.unavailable {
    background: #ff4d4f;
}

.legend-color.booked {
    background: #1890ff;
}
</style>
